import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Container,
  Card,
  Button,
  Alert,
} from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { FaFacebookSquare, FaSignOutAlt, FaCog } from "react-icons/fa";
import { adminAuthService } from "../../../services/api";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [adminUser, setAdminUser] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("info");

  useEffect(() => {
    // Get current admin user
    const currentAdmin = adminAuthService.getCurrentAdmin();
    setAdminUser(currentAdmin);
  }, []);

  const handleLogout = async () => {
    try {
      await adminAuthService.logout();
      setAlertVariant("success");
      setAlertMessage("ออกจากระบบสำเร็จ");
      setShowAlert(true);

      setTimeout(() => {
        navigate("/admin/login");
      }, 1000);
    } catch (error) {
      setAlertVariant("danger");
      setAlertMessage("เกิดข้อผิดพลาดในการออกจากระบบ");
      setShowAlert(true);
    }
  };

  return (
    <div className="admin-dashboard" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      <Container fluid>
        {/* Header */}
        <Row className="bg-white shadow-sm py-3 mb-4">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-0">Ruaysure Admin Dashboard</h3>
              <div className="d-flex align-items-center gap-3">
                {adminUser && (
                  <div className="text-end">
                    <small className="text-muted d-block">Logged in as</small>
                    <strong>{adminUser.username}</strong>
                    <span className="badge bg-primary ms-2">{adminUser.userType}</span>
                  </div>
                )}
                <Button variant="outline-danger" size="sm" onClick={handleLogout}>
                  <FaSignOutAlt className="me-2" />
                  ออกจากระบบ
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        {/* Main Content */}
        <Container>
          {showAlert && (
            <Alert
              variant={alertVariant}
              onClose={() => setShowAlert(false)}
              dismissible
              className="mb-4"
            >
              {alertMessage}
            </Alert>
          )}

          <Row className="mb-4">
            <Col>
              <h4 className="mb-3">ยินดีต้อนรับสู่แดชบอร์ดแอดมิน</h4>
              <p className="text-muted">
                จัดการการตั้งค่าระบบและการเชื่อมต่อ Facebook สำหรับ RuaySure
              </p>
            </Col>
          </Row>

          <Row>
            {/* Facebook Connection Card */}
            <Col md={6} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="d-flex flex-column">
                  <div className="text-center mb-4">
                    <div className="rounded-circle bg-primary bg-opacity-10 p-4 d-inline-flex mb-3">
                      <FaFacebookSquare size={48} className="text-primary" />
                    </div>
                    <h5>Facebook Integration</h5>
                    <p className="text-muted">
                      เชื่อมต่อบัญชี Facebook และจัดการเพจสำหรับระบบ RuaySure
                    </p>
                  </div>
                  <div className="mt-auto">
                    <Link to="/admin/facebook-connect">
                      <Button variant="primary" className="w-100">
                        <FaFacebookSquare className="me-2" />
                        จัดการการเชื่อมต่อ Facebook
                      </Button>
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* System Settings Card */}
            <Col md={6} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body className="d-flex flex-column">
                  <div className="text-center mb-4">
                    <div className="rounded-circle bg-secondary bg-opacity-10 p-4 d-inline-flex mb-3">
                      <FaCog size={48} className="text-secondary" />
                    </div>
                    <h5>System Settings</h5>
                    <p className="text-muted">
                      จัดการการตั้งค่าระบบและข้อมูลการกำหนดค่าต่างๆ
                    </p>
                  </div>
                  <div className="mt-auto">
                    <Button variant="secondary" className="w-100" disabled>
                      <FaCog className="me-2" />
                      Coming Soon
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Info Section */}
          <Row>
            <Col>
              <Card className="bg-light border-0">
                <Card.Body>
                  <h6 className="mb-3">Quick Guide</h6>
                  <ul className="mb-0">
                    <li className="mb-2">
                      <strong>Facebook Integration:</strong> เชื่อมต่อบัญชี Facebook ของคุณเพื่อเข้าถึงเพจที่คุณจัดการ
                    </li>
                    <li className="mb-2">
                      <strong>Configure RuaySure:</strong> เลือกเพจและกำหนดค่าสำหรับการใช้งาน RuaySure Bot
                    </li>
                    <li className="mb-2">
                      <strong>Token Management:</strong> ระบบจะดูแลการ refresh token อัตโนมัติ
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
};

export default AdminDashboard;
